import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavItemType } from '../../components/nav-items/models/nav-item-type.enum';
import { NavItemModel } from '../../components/nav-items/models/nav-item.model';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit {
  footerLinks: NavItemModel[] = [
    {
      name: 'footer.requestAdvice',
      type: NavItemType.Link,
      navigateTo: 'https://www.assekuranz.ch/servicecenter/kontakt',
    },
    {
      name: 'footer.overviewInsurances',
      type: NavItemType.Link,
      navigateTo:
        'https://www.assekuranz.ch/versicherung/ueberblick-versicherungen',
    },
    {
      name: 'footer.reportDamage',
      type: NavItemType.Link,
      navigateTo: 'pages/claim',
    },
    {
      name: 'footer.calculatePremium',
      type: NavItemType.Link,
      navigateTo: 'pages/calculator',
    },
    {
      name: 'footer.changeAddress',
      type: NavItemType.Link,
      navigateTo: '#',
    },
    {
      name: 'footer.downloads',
      type: NavItemType.Link,
      navigateTo: 'https://www.assekuranz.ch/servicecenter/downloads-und-links',
    },
    {
      name: 'footer.customerFeedback',
      type: NavItemType.Link,
      navigateTo: 'https://www.assekuranz.ch/servicecenter/kontakt',
    },
  ];

  contactItems: NavItemModel[] = [
    {
      name: 'footer.address',
      type: NavItemType.Text,
    },
    {
      name: 'footer.postalCode',
      type: NavItemType.Text,
    },
    {
      name: 'footer.email',
      type: NavItemType.Email,
      navigateTo: 'info@assekuranz.ch',
    },
    {
      name: 'footer.googleMaps',
      type: NavItemType.Link,
      navigateTo:
        'https://www.google.de/maps/place//@47.3847934,9.2750911,17z/data=!3m1!4b1?entry=ttu&g_ep=EgoyMDI0MTEyNC4xIKXMDSoASAFQAw%3D%3D',
    },
    {
      name: 'footer.contactPhone',
      type: NavItemType.Phone,
      navigateTo: '0713530053',
    },
  ];

  infoItems: NavItemModel[] = [
    {
      name: 'footer.openingHoursAm',
      type: NavItemType.Text,
    },
    {
      name: 'footer.openingHoursPm',
      type: NavItemType.Text,
    },
  ];

  show?: boolean;
  constructor(private router: Router) {}

  ngOnInit(): void {
    this.showFooter();
    this.router.events.subscribe((val) => {
      this.showFooter();
    });
  }

  showFooter(): void {
    if (this.router.url.includes('home')) {
      this.show = true;
    } else {
      this.show = false;
    }
  }
}
